import toggle from './toggle';

function toggleReadMore(container, baseClass) {

    container.classList.toggle(baseClass + '--showMore');
}

function initContainer(container) {
    const baseClass = container.getAttribute('data-base-class');
    const containerId = container.getAttribute('data-toggle-target-of');
    let button;

    if (containerId) {
        button = document.querySelector(`.js_globalReadMore__button[data-toggle-for-target="${containerId}"]`);
    }

    if (baseClass && button) {
        button.addEventListener('click', e => toggleReadMore(container, baseClass));
    }
}

function init() {
    const containers = [...document.querySelectorAll('.js_globalReadMore')];

    containers.forEach(initContainer);
}

$(document).ready(init);
